import moment from "moment";

export const transformUTCDate = (date: string) => {
  if (date == null) return null;
  if (Date.parse(date)) {
    return new Date(date).toLocaleString("en-US", {
      timeZone: "UTC",
      dateStyle: "short",
      timeStyle: "short",
    });
  }
  // {moment(moment.utc(data.createdDate).toDate()).format('MM-DD-YYYY HH:mm')}
  return date;
};
export const transformUTCDateWithoutTime = (date: string) => {
  if (date == null) return null;
  if (Date.parse(date)) {
    return new Date(date).toLocaleString("en-US", {
      timeZone: "UTC",
      dateStyle: "short",
    });
  }
  return date;
};
export const transformDateWithoutTime = (date: string) => {
  if (date == null) return null;
  if (Date.parse(date)) {
    return moment(date).format("MM/DD/YYYY");
  }
  return date;
};

export const transformDateWithDash = (date: string) => {
  if (date == null) return null;
  if (Date.parse(date)) {
    return moment(date).format("YYYY-MM-DD");
  }
  return date;
};

export const transformDateWithSlash = (date: string) => {
  if (date == null) return null;
  if (Date.parse(date)) {
    return moment(date).format("YYYY/MM/DD");
  }
  return date;
};
